// extracted by mini-css-extract-plugin
export var Modal = "index-module--Modal--2Oh9V";
export var title = "index-module--title--3xgou";
export var content = "index-module--content--1_nvH";
export var list = "index-module--list--3WsCD";
export var actions = "index-module--actions--12vdf";